import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import { http } from "@utils/http";
import { toast } from "react-toastify";
import { uploadActionI } from "@features/upload/type";
import i18n from "i18next";

export const handleUploadFile = createAsyncThunk(
  "byod/files/{filename}",

  async ({ fileName, body }: uploadActionI, { rejectWithValue }) => {
    try {
      const res = await http.post(`/byod/files/${fileName}`, body);
      return res.data;
    } catch (error: any) {
      return rejectWithValue(error);
    }
  }
);

export const revertAll = createAction("REVERT_ALL");
